import { useState, useEffect } from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

import * as apiComms from '../apiComms';
import * as logger from '../logger';

const PROG = 'ChartCollectorCardCompletionFunnel.js';

const CHART_COLOURS = ['#369fe3', '#20c997', '#f59f00', '#ff6b6b', '#845ef7'];

const ChartCollectorCardCompletionFunnel = (props) => {

  const [chartData, setChartData] = useState(null);
  const [collectorCardIds, setCollectorCardIds] = useState([]);
  const [isLoadingData, setIsLoadingData] = useState(true);

  useEffect(() => {
    const loadChartData = async () => {
      const FUNCTION = 'loadChartData';

      try {
        setIsLoadingData(true);
        const _chartDataResponse = await apiComms.getChartDataCollectorCardCompletionFunnel(props.timeRange);
        if (_chartDataResponse && !_chartDataResponse.isErr) {
          setChartData(_chartDataResponse.response.chartdata);
          setCollectorCardIds(_chartDataResponse.response.collectorCardIds || []);
        }
        setIsLoadingData(false);
      }
      catch (e) {
        logger.error('Exception Occured', { PROG, FUNCTION });
        console.log('Exception: '+e+', '+e.stack);
      }
    };

    loadChartData();
  }, [props.timeRange]);

  return (
    <div className='card'>
      <div style={{ display : 'flex', width : '100%', flexDirection : 'column', borderRadius: 10, overflow : 'hidden' }} >
        <div style={{ height : 300 }}>
          {!isLoadingData ? (
            <>
            {Array.isArray(chartData) && chartData.length > 0 ? (
            <ResponsiveContainer>
              <LineChart data={chartData} margin={{ top: 20, right: 20, left: 6, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="stampNumber" label={{ value: 'Stamp Number Reached', position: 'insideBottom', offset: -2 }} />
                <YAxis width={42} />
                <Tooltip />
                <Legend />
                {collectorCardIds.map((collectorCardId, index) => (
                  <Line
                    key={collectorCardId}
                    type="monotone"
                    dataKey={collectorCardId}
                    stroke={CHART_COLOURS[index % CHART_COLOURS.length]}
                    strokeWidth={2}
                    dot={false}
                    name={collectorCardId}
                  />
                ))}
              </LineChart>
            </ResponsiveContainer>
            ) : null }
            </>
          ) : null }
        </div>
        <div className='card-body'>
          Collector Card Completion Funnel
        </div>
      </div>
    </div>
  );
};

export default ChartCollectorCardCompletionFunnel;
